import React, { useEffect, useState } from "react";
import Notice from "../../assets/images/notice.svg";
import { Button, Modal, Popconfirm } from "antd";
import { useSettings } from "../../context/SettingsContext";
import { ShowToast, Severty } from "../../helper/toast";

function ActiveDevicesIndex() {
  const { activeDevices, setActiveDevice, getActiveDevices, revokeDevice } =
    useSettings();
  const [loadingId, setLoadingId] = useState(null);
  const [allLoading, setAllLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);
  const fetchDevices = async () => {
    try {
      const response = await getActiveDevices();
      if (response?.success) {
        setActiveDevice(response?.data?.devices);
      }
    } catch (error) {
      console.log(error, "---error-->");
    }
  };

  const revokeHandler = async (deviceId) => {
    setLoadingId(deviceId);
    try {
      const response = await revokeDevice(deviceId, true);
      if (response?.success) {
        fetchDevices();
        setIsModalOpen(false);
      }
    } catch (error) {
      ShowToast("Failed to revoke device", Severty.ERROR);
    } finally {
      setLoadingId(null);
    }
  };

  const revokeAllHandler = async () => {
    setAllLoading(true);
    try {
      const response = await revokeDevice(null, false); // revoke all others
      if (response?.success) {
        ShowToast("All other devices revoked successfully!", Severty.SUCCESS);
        fetchDevices();
      }
    } catch (error) {
      ShowToast("Failed to revoke devices", Severty.ERROR);
    } finally {
      setAllLoading(false);
    }
  };

  useEffect(() => {
    fetchDevices();
  }, []);

  return (
    <section>
      <div className="active-main-div  active-main-div_main setting-main-list">
        <div className="active-heading-div">
          <h1>Active Devices</h1>
          <p>
            These are the devices currently logged into your account. You can
            revoke access to any device you don't recognize.
          </p>
        </div>

        <div className="devices-container ">
          {activeDevices?.map((device) => (
            <div
              key={device.id}
              className={
                device.device_type === "mobile" ? "iphone-div" : "ipad-div"
              }
            >
              <div className="iphone-text-div">
                <div className="first-div-headin-iphone">
                  <h1>{device.device_name}</h1>
                  {device.is_current_device ? (
                    <h2>Current Device</h2>
                  ) : (
                    <h2>{device.platform} Browser</h2>
                  )}
                </div>
                <div className="sec-div-iphone">
                  <h1>
                    Last active: <span>{device.last_active}</span>
                  </h1>
                  <h2>
                    Location: <span>{device.location}</span>
                  </h2>
                </div>
              </div>

              <div className="active-btn">
                {device.is_current_device ? (
                  <button className="active-button">{device.status}</button>
                ) : (
                  <button
                    className="active-button active-button_revoke_button"
                    onClick={() => {
                      setSelectedDeviceId(device.device_id);
                      setIsModalOpen(true);
                    }}
                  >
                    Revoke
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
        <Modal
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          className="custome_mail_modal"
          centered
          footer={false}
        >
          <h4>Revoke Device</h4>
          <p>Are you sure you want to revoke this device?</p>
          <div className="custome_mail_modal_button">
            <Button
              className="border-button"
              key="cancel"
              onClick={() => setIsModalOpen(false)}
            >
              No
            </Button>
            <Button
              key="confirm"
              className="Fill-button"
              loading={loadingId === selectedDeviceId}
              onClick={() => {
                revokeHandler(selectedDeviceId);
              }}
            >
              Yes, Revoke
            </Button>
          </div>
        </Modal>

        {/* Revoke All Other Devices Button */}
        {/* <div style={{ marginTop: "20px", textAlign: "center" }}>
          <Popconfirm
            title="This will log out all devices except the current one. Continue?"
            onConfirm={revokeAll Handler}
            okText="Yes"
            cancelText="No"
          >
            <Button
              type="primary"
              danger
              loading={allLoading}
            >
              Revoke All Other Devices
            </Button>
          </Popconfirm>
        </div> */}

        <div className="notice-div">
          <div className="notice-icon">
            <img src={Notice} alt="notice-img" />
          </div>
          <div className="notice-pera">
            If you notice any suspicious activity, revoke access immediately and
            change your password.
          </div>
        </div>
      </div>
    </section>
  );
}

export default ActiveDevicesIndex;
